export default "__VITE_ASSET__a0299665__"